export default "__VITE_ASSET__CTHC$0H0__"